import type { SceneLayoutDeployTypeCode, SkuModuleMeta } from './types';

const SKU_MODULE_META_BY_DEPLOY: Partial<Record<SceneLayoutDeployTypeCode, Record<string, SkuModuleMeta>>> = {};

/** 插件注册 SKU 模块元信息（在 plugins/<Type>/index.ts side-effect 调用） */
export function registerSkuModuleMeta(deployTypeCode: SceneLayoutDeployTypeCode, meta: Record<string, SkuModuleMeta>): void {
  SKU_MODULE_META_BY_DEPLOY[deployTypeCode] = meta;
}

export function getSkuModuleMeta(deployTypeCode: SceneLayoutDeployTypeCode | undefined, moduleKey: string): SkuModuleMeta | undefined {
  if (!deployTypeCode) return undefined;
  return SKU_MODULE_META_BY_DEPLOY[deployTypeCode]?.[moduleKey];
}

export function getSkuModuleMetaMap(deployTypeCode: SceneLayoutDeployTypeCode): Record<string, SkuModuleMeta> {
  return SKU_MODULE_META_BY_DEPLOY[deployTypeCode] ?? {};
}
